import { render, staticRenderFns } from "./RegistrationDetailsInfo.vue?vue&type=template&id=1d13148f"
import script from "./RegistrationDetailsInfo.vue.ts?vue&type=script&lang=ts&external"
export * from "./RegistrationDetailsInfo.vue.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports